import { ContentfulIcon } from '@jbhi-fi/apis/src/contentful/types';
import { Icon, IconName } from '@jbhi-fi/lanyard-ui/components/Icon';
type IconProps = Parameters<typeof Icon>[0];

export abstract class IconTransformer {
  static toLazyIconProps = (entry?: ContentfulIcon): IconProps => {
    return {
      name: entry?.fields?.name as IconName,
      fallback: null,
      placeholder: null,
    };
  };
}
